module.exports = __webpack_public_path__ + "static/img/person_health_activities.04d5a4bf.png";